import {Injectable, signal} from '@angular/core';

type ToastType = 'success' | 'error' | 'info' | 'warning';
export class Toast {
  constructor(
    public id: number,
    public message: string,
    public type: ToastType = 'info',
  ) {}
}

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  private _toasts = signal<Toast[]>([]);
  public toasts = this._toasts.asReadonly();
  private id = 0;

  get(): any[]{
    return this._toasts();
  }

  show(message: string, type: ToastType, duration = 5000): void {
    const id = this.id++;
    this._toasts().push(new Toast(id, message, type));
    if (duration > 0) {
      setTimeout(() => this.remove(id), duration);
    }
  }

  success(message: string, duration = 5000): void {
    this.show(message, 'success', duration);
  }

  error(message: string, duration = 5000): void {
    this.show(message, 'error', duration);
  }

  remove(id: any): void{
    this._toasts.set(this.toasts().filter(t => t.id !== id));
  }
}
